import { motion } from 'framer-motion'
import DocsLayout from '../components/DocsLayout'
import SEO from '../components/SEO'
import {
  FaCompactDisc,
  FaSync,
  FaCogs,
  FaPlug,
  FaSave,
  FaArchive,
  FaTools,
  FaDownload,
  FaKey,
  FaWindows,
  FaApple,
  FaMagic,
  FaRocket,
  FaDesktop,
  FaStar,
  FaUsb
} from 'react-icons/fa'

const tools = [
  {
    name: "SysRi一键重装",
    description: "纯净无捆绑，强大且易用，一个纯净、强大、易用的系统重装工具，支持一键在线重装，兼容性极好，无论是技术员还是小白都能快速上手，省心且高效。",
    icon: <FaMagic />,
    downloadUrl: "https://sysri.cn",
    features: ["纯净无捆绑", "一键在线重装", "兼容性极好", "小白也能快速上手"],
    highlighted: true,
    bgColor: "bg-gradient-to-br from-purple-50 to-indigo-100",
    borderColor: "border-purple-300"
  },
  {
    name: "EasyRCV",
    description: "年轻人的第一款系统重装软件，可实现任何Windows系统下一键重装Windows系统，是当前最简单最快速的系统重装软件。",
    icon: <FaRocket />,
    downloadUrl: "https://firpe.cn/page-196",
    features: ["适合年轻人", "一键重装", "快速简单", "多系统支持"],
    highlighted: true,
    bgColor: "bg-gradient-to-br from-blue-50 to-cyan-100",
    borderColor: "border-blue-300"
  },
  {
    name: "TeamViewer",
    description: "远程重装系统必备。免费远程控制软件，个人非商业用途完全免费，连接、支持与协作。既能远程协助朋友、家人轻松解决IT难题，又能随时、随地访问您的个人设备。",
    icon: <FaDesktop />,
    downloadUrl: "https://www.teamviewer.cn/cn/solutions/roles/personal-use/",
    features: ["远程控制", "远程协助", "个人免费", "跨平台支持"],
    highlighted: true,
    bgColor: "bg-gradient-to-br from-blue-50 to-blue-100",
    borderColor: "border-blue-300"
  },
  {
    name: "Ventoy",
    description: "一个开源的多系统启动盘制作工具，支持多种系统镜像。",
    icon: <FaCompactDisc />,
    downloadUrl: "https://www.ventoy.net/",
    features: ["支持多种系统", "无需格式化U盘", "支持Legacy和UEFI"]
  },
  {
    name: "Rufus",
    description: "一个轻量级的Windows系统启动盘制作工具。",
    icon: <FaSync />,
    downloadUrl: "https://rufus.ie/",
    features: ["快速制作启动盘", "支持多种镜像格式", "简单易用"]
  },
  {
    name: "NTLite",
    description: "Windows系统精简和定制工具，可以移除不需要的组件。",
    icon: <FaCogs />,
    downloadUrl: "https://www.ntlite.com/",
    features: ["系统精简", "组件移除", "系统定制"]
  },
  {
    name: "Driver Booster",
    description: "驱动更新和安装工具，可以自动检测和安装最新驱动。",
    icon: <FaPlug />,
    downloadUrl: "https://www.iobit.com/en/driver-booster.php",
    features: ["驱动更新", "驱动备份", "一键安装"]
  },
  {
    name: "AOMEI Backupper",
    description: "系统备份和还原工具，支持系统迁移和克隆。",
    icon: <FaSave />,
    downloadUrl: "https://www.aomeitech.com/aomei-backupper.html",
    features: ["系统备份", "磁盘克隆", "增量备份"]
  },
  {
    name: "7-Zip",
    description: "强大的压缩和解压缩工具，支持多种压缩格式。",
    icon: <FaArchive />,
    downloadUrl: "https://7-zip.org/",
    features: ["高压缩率", "支持多种格式", "开源免费"]
  }
]

const sidebarItems = [
  { title: "装机工具", path: "/tools", icon: <FaTools /> },
  { title: "PE工具", path: "/petools", icon: <FaCompactDisc /> },
  { title: "激活工具", path: "/activators", icon: <FaKey /> },
  { title: "系统下载", path: "/downloads", icon: <FaDownload /> },
  { title: "Windows软件", path: "/windows-software", icon: <FaWindows /> },
  { title: "MacOS软件", path: "/macos-software", icon: <FaApple /> },
  { title: "安装U盘推荐", path: "/usb-recommend", icon: <FaUsb /> },
  { title: "电脑选购推荐", path: "/computer-recommend", icon: <FaDesktop /> }
]

const Tools = () => {
  return (
    <DocsLayout sidebarItems={sidebarItems}>
      <SEO 
        title="装机必备工具推荐 | 系统重装工具 | 一键重装系统软件"
        description="精选装机必备工具推荐，包括一键重装系统工具、PE制作工具、系统激活工具等，让你的电脑重装系统过程更加简单便捷。"
        keywords="装机工具,系统重装工具,一键重装系统软件,PE工具,系统激活工具,U盘启动工具,Ventoy,Rufus,微PE,系统安装工具"
      />
      <motion.h1 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-bold text-primary mb-8 text-center"
      >
        装机必备工具推荐 <FaTools className="inline text-primary ml-1" />
      </motion.h1>
      
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {tools.map((tool, index) => (
          <motion.div
            key={tool.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className={`card ${tool.highlighted ? 'transform hover:-translate-y-2 ' + tool.bgColor + ' border-2 ' + tool.borderColor : ''}`}
          >
            <div className="flex items-center mb-4">
              <div className={`text-2xl p-2 rounded-full mr-3 ${tool.highlighted ? 'text-white bg-primary' : 'text-primary'}`}>
                {tool.icon}
                {tool.highlighted && <FaStar className="absolute top-0 right-0 text-yellow-400 text-xs" />}
              </div>
              <h3 className={`text-xl font-semibold ${tool.highlighted ? 'text-primary' : 'text-gray-800'}`}>
                {tool.name}
                {tool.highlighted && 
                  <span className="ml-2 text-xs bg-yellow-100 text-yellow-700 px-2 py-1 rounded-full">
                    推荐
                  </span>
                }
              </h3>
            </div>
            <p className="text-gray-600 mb-4">{tool.description}</p>
            <div className="mb-4">
              <h4 className="font-medium text-gray-700 mb-2">主要功能：</h4>
              <ul className="list-disc list-inside text-sm text-gray-600">
                {tool.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
            </div>
            <a
              href={tool.downloadUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`inline-block text-white px-4 py-2 rounded-lg transition-colors ${tool.highlighted ? 'bg-gradient-to-r from-primary to-blue-700 shadow-md hover:shadow-lg' : 'bg-primary hover:bg-blue-600'}`}
            >
              下载地址
            </a>
          </motion.div>
        ))}
      </div>
    </DocsLayout>
  )
}

export default Tools 